import React from 'react';
import { ScaleIcon } from 'lucide-react';
import { costRows } from '../data/content';
export function CostSection() {
  return <section className="w-full bg-ink-900 py-20" aria-labelledby="cost-title" data-id="element-34" data-mp="9d9anmxuss9z">
      <div className="mx-auto max-w-4xl px-5" data-id="element-35" data-mp="4kg6b06arlyf">
        <div className="flex flex-col items-center gap-4 text-center" data-id="element-36" data-mp="4j52j0cuqe7b">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold-500/15" data-id="element-37" data-mp="3vqznqy6n2a5p">
            <ScaleIcon className="h-5 w-5 text-gold-500" aria-hidden="true" data-id="element-38" data-mp="3qtzham5vn5e2" />
          </span>
          <h2 id="cost-title" className="font-display text-3xl uppercase leading-tight text-cream sm:text-4xl" data-id="element-39" data-mp="3mq1dvz9ir8f7">
            ¿Cuánto cuesta <span className="text-rose-400" data-id="element-40" data-mp="3ct6ivqcgfq5o">NO</span> tenerlo?
          </h2>
          <p className="max-w-xl text-sm leading-relaxed text-cream/65 sm:text-base" data-id="element-41" data-mp="3cuzor3f8u6cm">
            El problema no es el precio del MegaPack. El problema es el costo invisible de seguir
            igual.
          </p>
        </div>

        <div className="mt-12 overflow-hidden rounded-2xl border border-cream/10" data-id="element-42" data-mp="p7bole38k8ka">
          <div className="grid grid-cols-2 bg-ink-800" data-id="element-43" data-mp="t8wzitw7mcru">
            <div className="px-4 py-3 text-xs font-bold uppercase tracking-[0.14em] text-cream/60 sm:px-6" data-id="element-44" data-mp="tahtoiem3tp6">
              Sin MegaPack
            </div>
            <div className="border-l border-cream/10 px-4 py-3 text-xs font-bold uppercase tracking-[0.14em] text-rose-400 sm:px-6" data-id="element-45" data-mp="k7yty764hx75">
              Costo real
            </div>
          </div>
          <ul data-id="element-46" data-mp="1cxnteg36pp6n">
            {costRows.map((row, i) => <li key={row.without} className={`grid grid-cols-2 border-t border-cream/10 ${i % 2 === 0 ? 'bg-ink-950/60' : 'bg-ink-900'}`} data-id="element-47" data-mp="1cwctircv11kt" data-mpi={i}>
                <p className="px-4 py-4 text-sm text-cream/75 sm:px-6" data-id="element-48" data-mp="135rr0su2fcwm">{row.without}</p>
                <p className="border-l border-cream/10 px-4 py-4 text-sm text-rose-300/85 sm:px-6" data-id="element-49" data-mp="1qw5fyahcsvmz">
                  {row.cost}
                </p>
              </li>)}
          </ul>
        </div>

        <div className="mt-10 rounded-2xl border border-gold-500/25 bg-ink-800/60 px-6 py-8 text-center" data-id="element-50" data-mp="25j451ysqndyj">
          <p className="font-display text-xl uppercase text-cream sm:text-2xl" data-id="element-51" data-mp="20lc8usl295oj">
            El próximo lunes puede ser diferente.
          </p>
          <p className="mt-2 text-sm italic text-gold-400" data-id="element-52" data-mp="1rke58bejb06h">
            “La próxima semana puede ser la mejor de tu proceso.”
          </p>
        </div>
      </div>
    </section>;
}